import custSourceReportNoStrain from './custSourceReportNoStrain'
export default custSourceReportNoStrain
